export const singular = {
    news: 'Новость',
    feat: 'Статья',
    secret: 'Секрет',
    video: 'Трейлер',
    files: 'Файл',
    compilation: 'Подборка',
    static: 'Статичный',
    gof: 'Новость',
    cybersport: 'Киберспорт',
    file: 'Файлы (Моды)',
};

export const articleTypes = ['feat', 'secret', 'file'];

export const disciplinesList = [
    { id: 'phygital-cs-go', name: 'CS:GO', isGof: true },
    { id: 'phygital-warface', name: 'Warface', isGof: true },
    { id: 'phygital-standoff-2', name: 'Standoff-2', isGof: true },
    { id: 'phygital-mlbb', name: 'MLBB', isGof: true },
    { id: 'phygital-dota-2', name: 'Dota 2', isGof: true },
    { id: 'phygital-skateboard', name: 'Скейтборд', isGof: true },
    { id: 'phygital-speedrun', name: 'Спидран', isGof: true },
    { id: 'phygital-racing', name: 'Гонки', isGof: true },
    { id: 'phygital-fighting', name: 'Единоборства', isGof: true },
    { id: 'phygital-hockey', name: 'Хоккей', isGof: true },
    { id: 'phygital-football', name: 'Футбол', isGof: true },
    { id: 'phygital-basketball', name: 'Баскетболл', isGof: true },
    { id: 'phygital-drone-racing', name: 'Дрон-рейсинг', isGof: true },
    { id: 'phygital-tanks', name: 'Мир танков', isGof: true },
    { id: 'phygital-robots', name: 'Роботы', isGof: true },
    { id: 'phygital-programming', name: 'Спортивное программирование', isGof: true },
    { id: 'phygital-other', name: 'Другие', isGof: true },
];
